import { render, staticRenderFns } from "./RiskCheckCheckLog.vue?vue&type=template&id=5687f41e&scoped=true"
import script from "./RiskCheckCheckLog.vue?vue&type=script&lang=js"
export * from "./RiskCheckCheckLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687f41e",
  null
  
)

export default component.exports